// extracted by mini-css-extract-plugin
module.exports = {"operatorsSection":"styles-module__operatorsSection___6HVpS","investorsSection":"styles-module__investorsSection___NS6ds","emergingSection":"styles-module__emergingSection___y4SxU"};